var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50004 1.5L4.49101 4.49097M16.5 16.5L13.5094 13.5093M10.5624 14.6872C10.0565 14.7831 9.53431 14.8333 9.00042 14.8333C5.26905 14.8333 2.11046 12.3809 1.04858 8.99997C1.33767 8.07958 1.78213 7.22801 2.35124 6.47598M7.23227 7.23223C7.68468 6.77982 8.30968 6.5 9.00004 6.5C10.3808 6.5 11.5 7.61929 11.5 9C11.5 9.69036 11.2202 10.3154 10.7678 10.7678M7.23227 7.23223L10.7678 10.7678M7.23227 7.23223L4.49101 4.49097M10.7678 10.7678L4.49101 4.49097M10.7678 10.7678L13.5094 13.5093M4.49101 4.49097C5.79086 3.65295 7.33884 3.16667 9.00041 3.16667C12.7318 3.16667 15.8904 5.61909 16.9522 9.00003C16.3632 10.8756 15.1288 12.4654 13.5094 13.5093",
    stroke: "#3E5468",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.670b94a480f16208b42568db8c62e44f.svg";
export { ForwardRef as ReactComponent };